import mixpanel from 'mixpanel-browser';

const token = process.env.REACT_APP_MIXPANEL_KEY;

mixpanel.init(token, {
    debug: process.env.NODE_ENV !== 'production', // log in dev
    api_host: 'https://api.mixpanel.com', // change to api-eu.mixpanel.com if EU project
});

let env_check = !!token; // only disable if no token

let actions = {
    identify: (id) => {
        if (env_check) {
            console.log('[Mixpanel] identify', id);
            mixpanel.identify(id);
        }
    },
    alias: (id) => {
        if (env_check) {
            console.log('[Mixpanel] alias', id);
            mixpanel.alias(id);
        }
    },
    track: (name, props) => {
        if (env_check) {
            console.log('[Mixpanel] track', name, props);
            mixpanel.track(name, props);
        }
    },
    people: {
        set: (props) => {
            if (env_check) {
                console.log('[Mixpanel] people.set', props);
                mixpanel.people.set(props);
            }
        },
    },
};

export let Mixpanel = actions;
